import React from 'react'
import '../style.css'
import FormRegister from './components/FormRegister'

const Register = () => {
  return (
    <section id='register'>
      <div className="container">
        <h3>Registrasi</h3>
        <div className="form">
          <FormRegister />
        </div>
        <p className="hp-bottom-note">
          Butuh bantuan memilih program? <a href="https://wa.me/6281138914770" target="_blank" rel="noreferrer" className="hp-bottom-link">Hubungi konsultan kami secara gratis <i className="fa-brands fa-whatsapp" /></a>
        </p>
      </div>
    </section>
  )
}

export default Register